import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LayoutDashboard, LogOut } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth, HOME_BY_ROLE } from "@/context/AuthContext";

const LINKS = [
  ["Find Jobs", "/jobs"],
  ["Career Resources", "/career-resources"],
  ["For Employers", "/for-employers"],
  ["For Colleges", "/for-colleges"],
  ["About", "/about"],
];

export function AnnouncementBar() {
  return (
    <div data-testid="announcement-bar" className="bg-[#0B1B2B] text-white">
      <div className="container-x flex h-9 items-center justify-center text-xs font-medium sm:justify-between">
        <span className="hidden sm:block" />
        <span className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[#00B94F]" />Your next opportunity starts here</span>
        <span className="hidden text-white/70 sm:block">India's all-category job platform</span>
      </div>
    </div>
  );
}

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const linkCls = ({ isActive }) => `text-sm font-medium transition-colors hover:text-[#00B94F] ${isActive ? "text-[#00B94F]" : "text-[#0B1B2B]/80"}`;
  return (
    <header data-testid="main-nav" className="sticky top-0 z-40 border-b border-[#e3ece6] bg-white/90 backdrop-blur-md">
      <div className="container-x flex h-16 items-center justify-between">
        <Logo />
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map(([l, h]) => <NavLink key={h} to={h} className={linkCls} data-testid={`nav-${h.slice(1)}`}>{l}</NavLink>)}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          {user ? (
            <>
              <Link to={HOME_BY_ROLE[user.role]} className="btn-outline" data-testid="nav-dashboard-btn"><LayoutDashboard size={16} />Dashboard</Link>
              <button className="btn-ghost" data-testid="nav-logout-btn" onClick={async () => { await logout(); nav("/"); }}><LogOut size={16} /></button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-outline" data-testid="nav-login-btn">Login</Link>
              <Link to="/signup" className="btn-green" data-testid="nav-signup-btn">Sign Up Free</Link>
            </>
          )}
        </div>
        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">{open ? <X /> : <Menu />}</button>
      </div>
      {open && (
        <div className="border-t border-[#e3ece6] bg-white lg:hidden" data-testid="nav-mobile-menu">
          <div className="container-x flex flex-col gap-4 py-4">
            {LINKS.map(([l, h]) => <NavLink key={h} to={h} className={linkCls} onClick={() => setOpen(false)}>{l}</NavLink>)}
            <div className="flex gap-3">
              {user ? <Link to={HOME_BY_ROLE[user.role]} className="btn-green flex-1" onClick={() => setOpen(false)}>Dashboard</Link> : (
                <>
                  <Link to="/login" className="btn-outline flex-1" onClick={() => setOpen(false)}>Login</Link>
                  <Link to="/signup" className="btn-green flex-1" onClick={() => setOpen(false)}>Sign Up Free</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
